import {parseQueryString, toQueryString as toQueryParams} from '@s-ui/js/lib/string'

import DealerEntitiesFactory from '../../dealer/Entities/factory.js'
// Foreign context imports
import DealerMappersFactory from '../../dealer/Mappers/factory.js'
import PageServicesFactory from '../../page/Services/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import {SellerMappersFactory} from '../../seller/Mappers/factory.js'
import {SellerValueObjectsFactory} from '../../seller/ValueObjects/factory.js'
import UserEntitiesFactory from '../../user/Entities/factory.js'
import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import VehiclesValueObjectsFactory from '../../vehicles/ValueObjects/factory.js'
import {AdsAggregatesFactory} from '../Aggregates/factory.js'
import AdsEntitiesFactory from '../Entities/factory.js'
import AdsErrorsFactory from '../Errors/factory.js'
// Context Ads imports
import AdsValueObjectsFactory from '../ValueObjects/factory.js'
import AdEntityToAdSearchParamsVOMapper from './AdEntityToAdSearchParamsVOMapper.js'
// Mappers
import {AdsRawListToAdsListVOMapper} from './AdsRawListToAdsListVOMapper.js'
import AdsSearchParamsHttpToValueObjectMapper from './AdsSearchParamsHttpToValueObjectMapper.js'
import AdsSearchParamsValueObjectToHttpMapper from './AdsSearchParamsValueObjectToHttpMapper.js'
import {FinancingTermsRawDataToFinancingConditionEntityMapper} from './FinancingTermsRawDataToFinancingConditionEntityMapper.js'
import {FromAdAggregationRawDataToAdAggregationListValueObjectMapper} from './FromAdAggregationRawDataToAdAggregationListValueObjectMapper.js'
import {FromAdAggregationsRawDataToAdAggregationsListValueObjectMapper} from './FromAdAggregationsRawDataToAdAggregationsListValueObjectMapper.js'
import {FromAdDetailsRawDataToAdEntityMapper} from './FromAdDetailsRawDataToAdEntityMapper.js'
import {FromAdDetailsRawDataToAdTypeValueObjectMapper} from './FromAdDetailsRawDataToAdTypeValueObjectMapper.js'
import {FromAdDetailsRawDataToSellerValueObjectMapper} from './FromAdDetailsRawDataToSellerValueObjectMapper.js'
import {FromAdDetailsRawDataToVehicleCertificationValueObjectMapper} from './FromAdDetailsRawDataToVehicleCertificationValueObjectMapper.js'
import {FromAdDetailsRawDataToVehicleHistoryValueObjectMapper} from './FromAdDetailsRawDataToVehicleHistoryValueObjectMapper.js'
import {FromAdDetailsRawDataToVehicleInfoValueObjectMapper} from './FromAdDetailsRawDataToVehicleInfoValueObjectMapper.js'
import {FromAdDetailsStatsRawDataToAdStatsValueObjectMapper} from './FromAdDetailsStatsRawDataToAdStatsValueObjectMapper.js'
import {FromAdRawDataToAdEntityMapper} from './FromAdRawDataToAdEntityMapper.js'
import {FromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper} from './FromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper.js'
import {FromLoanCalculationsToFinancingDataAggregateMapper} from './FromLoanCalculationsToFinancingDataAggregateMapper.js'
import {FromRecommendedAdsRawDataToRecommendedAdsListVOMapper} from './FromRecommendedAdsRawDataToRecommendedAdsListVOMapper.js'
import {FromSearchParamsToStatsRequestVOMapper} from './FromSearchParamsToStatsRequestVOMapper.js'
import {FromStatsResponseToVOMapper} from './FromStatsResponseToVOMapper.js'
import HttpAdDetailsResponseToAdDetailsAggregateMapper from './HttpAdDetailsResponseToAdDetailsAggregateMapper.js'
import {HttpMakeModelAdsListingToAdsListValueObjectMapper} from './HttpMakeModelAdsListingToAdsListValueObjectMapper.js'
import HTTPRelatedAdsResponseJSONtoAdEntityMapper from './HTTPRelatedAdsResponseJSONtoAdEntityMapper.js'
import {HttpRelatedSubscriptionAdsResponseToSubscriptionAdsListValueObjectMapper} from './HttpRelatedSubscriptionAdsResponseToSubscriptionAdsListValueObjectMapper.js'
import HttpSearchResultsResponseToAdsListValueObjectMapper from './HttpSearchResultsResponseToAdsListValueObjectMapper.js'
import HttpSearchUrlResponseToSearchDataAdsValueObjectMapper from './HttpSearchUrlResponseToSearchDataAdsValueObjectMapper.js'
import {HttpSubscriptionCommitmentOptionsResponseToSubscriptionCommitmentOptionsValueObjectMapper} from './HttpSubscriptionCommitmentOptionsResponseToSubscriptionCommitmentOptionsValueObjectMapper.js'
import {HttpSubscriptionSearchResultsResponseToSubscriptionAdsListValueObjectMapper} from './HttpSubscriptionSearchResultsResponseToSubscriptionAdsListValueObjectMapper.js'
import LastAdsSearchLegacyParamsMapper from './LastAdsSearchLegacyParamsMapper.js'
import {LastDetailsViewedDataToLastDetailsViewedListValueObjectMapper} from './LastDetailsViewedDataToLastDetailsViewedListValueObjectMapper.js'
import {LastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper} from './LastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper.js'
import LastSearchesDataToSearchesListValueObjectMapper from './LastSearchesDataToSearchesListValueObjectMapper.js'
import RelatedAdsRequestValueObjectMapper from './RelatedAdsRequestValueObjectMapper.js'
import {RelatedSubscriptionAdsRequestValueObjectMapper} from './RelatedSubscriptionAdsRequestValueObjectMapper.js'
import SearchItemJsonToSearchItemValueObjectMapper from './SearchItemJsonToSearchItemValueObjectMapper.js'
import SearchRequestJSONToCochesParamsJSONMapper from './SearchRequestJSONToCochesParamsJSONMapper.js'
import SearchRequestJSONToMotosParamsJSONMapper from './SearchRequestJSONToMotosParamsJSONMapper.js'
import SearchRequestJSONToSearchParamsRequestJSONMapper from './SearchRequestJSONToSearchParamsRequestJSONMapper.js'
import SearchResultsFavoritesToAdsListValueObjectMapper from './SearchResultsFavoritesToAdsListValueObjectMapper.js'
export default class AdsMappersFactory {
  /**
   * @param {Object} deps
   * @param {Array} deps.arrBodyType
   * @param {Boolean} deps.Financed
   * @param {Boolean} deps.WithWarranty
   * @param {Number} deps.ContractId
   * @param {Number} deps.OfferType
   * @param {Number} deps.PowerHpTo
   * @param {Number} deps.Section2Id
   * @param {Number} deps.Section3Id
   * @param {String} deps.FuelTypeId
   * @param {String} deps.KeyWords
   * @param {String} deps.MakeId
   * @param {String} deps.MaxKms
   * @param {String} deps.MaxPrice
   * @param {String} deps.MaxYear
   * @param {String} deps.MinKms
   * @param {String} deps.MinPrice
   * @param {String} deps.MinYear
   * @param {String} deps.Model
   * @param {String} deps.ModelId
   * @param {String} deps.PowerHpFrom
   * @param {String} deps.ProvinceId
   * @param {String} deps.Section1Id
   * @param {String} deps.SellerTypeId
   * @param {String} deps.TransmissionTypeId
   * @param {String} deps.Version
   * @return {LastAdsSearchLegacyParamsMapper}
   */
  static lastAdsSearchLegacyParamsMapper = ({
    arrBodyType,
    FuelTypeId,
    MaxKms,
    MinKms,
    ModelId,
    MakeId,
    MaxPrice,
    ProvinceId,
    MaxYear,
    MinYear,
    KeyWords,
    ContractId,
    Financed,
    MinPrice,
    Model,
    OfferType,
    PowerHpFrom,
    PowerHpTo,
    Section1Id,
    Section2Id,
    Section3Id,
    SellerTypeId,
    TransmissionTypeId,
    Version,
    WithWarranty
  } = {}) =>
    new LastAdsSearchLegacyParamsMapper({
      arrBodyType,
      ContractId,
      Financed,
      FuelTypeId,
      KeyWords,
      MakeId,
      MaxKms,
      MaxPrice,
      MaxYear,
      MinKms,
      MinPrice,
      MinYear,
      Model,
      ModelId,
      OfferType,
      PowerHpFrom,
      PowerHpTo,
      ProvinceId,
      Section1Id,
      Section2Id,
      Section3Id,
      SellerTypeId,
      TransmissionTypeId,
      Version,
      WithWarranty
    })

  /**
   * @param {Object} deps
   * @param {Array} deps.bodyTypeIds
   * @param {Number} deps.count
   * @param {Number} deps.fuelTypeId
   * @param {Number} deps.makeId
   * @param {Number} deps.modelId
   * @param {Number} deps.provinceId
   * @param {Object} deps.odometerReading
   * @param {String} deps.keywords
   * @return {AdsSearchParamsHttpToValueObjectMapper}
   */
  static adsSearchParamsHttpToValueObjectMapper = ({
    bodyTypeIds,
    count,
    fuelTypeId,
    keywords,
    makeId,
    modelId,
    odometerReading,
    provinceId
  } = {}) =>
    new AdsSearchParamsHttpToValueObjectMapper({
      bodyTypeIds,
      count,
      fuelTypeId,
      keywords,
      makeId,
      modelId,
      odometerReading,
      provinceId
    })

  /**
   * @param {Object} deps
   * @param {Array} deps.bodyTypes
   * @param {Boolean} deps.financed
   * @param {Boolean} deps.withWarranty
   * @param {Number} deps.brand
   * @param {Number} deps.contractId
   * @param {Number} deps.count
   * @param {Array} deps.equipments
   * @param {Number} deps.fuelType
   * @param {Number} deps.kmsMax
   * @param {Number} deps.kmsMin
   * @param {Number} deps.maxPowerHp
   * @param {Number} deps.minPowerHp
   * @param {Number} deps.model
   * @param {Number} deps.offerType
   * @param {Number} deps.offset
   * @param {Number} deps.priceMax
   * @param {Number} deps.priceMin
   * @param {Number} deps.province
   * @param {Number} deps.section1Id
   * @param {Number} deps.section2Id
   * @param {Number} deps.section3Id
   * @param {Number} deps.sellerTypeId
   * @param {Number} deps.transmissionTypeId
   * @param {Number} deps.yearMax
   * @param {Number} deps.yearMin
   * @param {String} deps.keywords
   * @param {String} deps.modelLiteral
   * @param {String} deps.sortField
   * @param {String} deps.sortType
   * @param {String} deps.version
   * @return {AdsSearchParamsValueObjectToHttpMapper}
   */
  static adsSearchParamsValueObjectToHttpMapper = ({
    bodyTypes,
    brand,
    contractId,
    count,
    equipments,
    financed,
    fuelType,
    keywords,
    kmsMax,
    kmsMin,
    maxPowerHp,
    minPowerHp,
    model,
    modelLiteral,
    offerType,
    offset,
    priceMax,
    priceMin,
    province,
    section1Id,
    section2Id,
    section3Id,
    sellerTypeId,
    sortField,
    sortType,
    transmissionTypeId,
    vehicles,
    version,
    withWarranty,
    yearMax,
    yearMin
  } = {}) =>
    new AdsSearchParamsValueObjectToHttpMapper({
      bodyTypes,
      brand,
      contractId,
      count,
      equipments,
      financed,
      fuelType,
      keywords,
      kmsMax,
      kmsMin,
      maxPowerHp,
      minPowerHp,
      model,
      modelLiteral,
      offerType,
      offset,
      priceMax,
      priceMin,
      province,
      section1Id,
      section2Id,
      section3Id,
      sellerTypeId,
      sortField,
      sortType,
      transmissionTypeId,
      vehicles,
      version,
      withWarranty,
      yearMax,
      yearMin
    })

  static hTTPRelatedAdsResponseJSONtoAdEntityMapper = ({config}) =>
    new HTTPRelatedAdsResponseJSONtoAdEntityMapper({
      config,
      adEntity: AdsEntitiesFactory.adEntity
    })

  static fromSearchJSONToUrlVOMapper = ({config}) => {
    const APP_NAME = config.get('APP_NAME')
    const APP_NAME_COCHES = config.get('APP_NAME_COCHES')

    const Mapper =
      APP_NAME === APP_NAME_COCHES
        ? SearchRequestJSONToCochesParamsJSONMapper
        : SearchRequestJSONToMotosParamsJSONMapper

    return new Mapper({
      config,
      parseQueryString,
      toQueryParams
    })
  }

  static searchItemJsonToSearchItemValueObjectMapper = ({config}) =>
    new SearchItemJsonToSearchItemValueObjectMapper({
      toQueryParams,
      searchItemValueObjectFactory: AdsValueObjectsFactory.searchItemValueObject,
      getUrlService: PageServicesFactory.getUrlService({config})
    })

  static lastSearchesDataToSearchesListValueObjectMapper = ({config}) =>
    new LastSearchesDataToSearchesListValueObjectMapper({
      searchesListValueObjectFactory: AdsValueObjectsFactory.searchesListValueObject,
      searchItemJsonToSearchItemValueObjectMapper: AdsMappersFactory.searchItemJsonToSearchItemValueObjectMapper({
        config
      })
    })

  static httpRelatedSubscriptionAdsResponseToSubscriptionAdsListValueObjectMapper = ({config}) =>
    new HttpRelatedSubscriptionAdsResponseToSubscriptionAdsListValueObjectMapper({
      config,
      subscriptionAdEntityFactory: AdsEntitiesFactory.subscriptionAdEntity,
      subscriptionAdsListValueObjectFactory: AdsValueObjectsFactory.subscriptionAdsListValueObject
    })

  static httpSearchResultsResponseToAdsListValueObjectMapper = ({config}) =>
    new HttpSearchResultsResponseToAdsListValueObjectMapper({
      fromAdRawDataToAdEntityMapper: AdsMappersFactory.fromAdRawDataToAdEntityMapper(),
      adsListValueObjectFactory: AdsValueObjectsFactory.adsListValueObject,
      fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper:
        AdsMappersFactory.fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper({config})
    })

  static httpMakeModelAdsListingToAdsListValueObjectMapper = ({config}) =>
    new HttpMakeModelAdsListingToAdsListValueObjectMapper({
      httpSearchResultsResponseToAdsListValueObjectMapper:
        AdsMappersFactory.httpSearchResultsResponseToAdsListValueObjectMapper({
          config,
          adsListValueObject: AdsValueObjectsFactory.adsListValueObject,
          adEntity: AdsEntitiesFactory.adEntity
        }),
      wdylAdsValueObjectFactory: AdsValueObjectsFactory.wdylAdsValueObject
    })

  static httpSearchUrlResponseToSearchDataAdsValueObjectMapper = ({config}) =>
    new HttpSearchUrlResponseToSearchDataAdsValueObjectMapper({
      config,
      searchDataAdsValueObjectFactory: AdsValueObjectsFactory.searchDataAdsValueObject,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static searchRequestJSONToSearchParamsRequestJSONMapper = ({config}) =>
    new SearchRequestJSONToSearchParamsRequestJSONMapper({config})

  static searchResultsFavoritesToAdsListValueObjectMapper = ({config}) =>
    new SearchResultsFavoritesToAdsListValueObjectMapper({
      config,
      adEntityFactory: AdsEntitiesFactory.adEntity,
      adsListValueObjectFactory: AdsValueObjectsFactory.adsListValueObject
    })

  static httpSubscriptionSearchResultsResponseToSubscriptionAdsListValueObjectMapper = ({config}) =>
    new HttpSubscriptionSearchResultsResponseToSubscriptionAdsListValueObjectMapper({
      config,
      subscriptionAdEntityFactory: AdsEntitiesFactory.subscriptionAdEntity,
      subscriptionAdsListValueObjectFactory: AdsValueObjectsFactory.subscriptionAdsListValueObject
    })

  static httpSubscriptionCommitmentOptionsResponseToSubscriptionCommitmentOptionsValueObjectMapper = ({config}) =>
    new HttpSubscriptionCommitmentOptionsResponseToSubscriptionCommitmentOptionsValueObjectMapper({
      config,
      subscriptionCommitmentOptionsValueObjectFactory: AdsValueObjectsFactory.subscriptionCommitmentOptionsValueObject
    })

  static relatedAdsRequestValueObjectMapper = ({config}) =>
    new RelatedAdsRequestValueObjectMapper({
      config,
      relatedAdsRequestValueObjectFactory: AdsValueObjectsFactory.RelatedAdsRequestValueObject
    })

  static relatedSubscriptionAdsRequestValueObjectMapper = ({config}) =>
    new RelatedSubscriptionAdsRequestValueObjectMapper({
      config,
      relatedAdsRequestValueObjectFactory: AdsValueObjectsFactory.RelatedAdsRequestValueObject
    })

  static adEntityToAdSearchParamsVOMapper = ({config}) =>
    new AdEntityToAdSearchParamsVOMapper({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static fromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper = ({config}) =>
    new FromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper({
      adsListValueObjectFactory: AdsValueObjectsFactory.adsListValueObject
    })

  static fromAdDetailsRawDataToAdEntityMapper = ({config}) =>
    new FromAdDetailsRawDataToAdEntityMapper({
      adEntityFactory: AdsEntitiesFactory.adEntity,
      config,
      getSellerRequestMapper: SellerMappersFactory.getSellerRequestMapper({
        config
      })
    })

  static fromAdDetailsStatsRawDataToAdStatsValueObjectMapper = ({config}) =>
    new FromAdDetailsStatsRawDataToAdStatsValueObjectMapper({
      adStatsValueObjectFactory: AdsValueObjectsFactory.adStatsValueObject,
      config
    })

  static fromAdDetailsRawDataToAdTypeValueObjectMapper = ({config}) =>
    new FromAdDetailsRawDataToAdTypeValueObjectMapper({
      adTypeValueObjectFactory: AdsValueObjectsFactory.adTypeValueObject,
      config
    })

  static fromAdDetailsRawDataToSellerValueObjectMapper = ({config}) =>
    new FromAdDetailsRawDataToSellerValueObjectMapper({
      config,
      fromDealerRawDataToDealerEntityMapper: DealerMappersFactory.fromDealerRawDataToDealerEntityMapper({config}),
      getSellerRequestMapper: SellerMappersFactory.getSellerRequestMapper({
        config
      }),
      sellerValueObjectFactory: SellerValueObjectsFactory.sellerValueObject,
      userEntityFactory: UserEntitiesFactory.userEntity
    })

  static fromAdDetailsRawDataToVehicleCertificationValueObjectMapper = ({config}) =>
    new FromAdDetailsRawDataToVehicleCertificationValueObjectMapper({
      config,
      fromVehicleCertificationRawDataToVehicleCertificationVOMapper:
        VehiclesMappersFactory.fromVehicleCertificationRawDataToVehicleCertificationVOMapper({config})
    })

  static fromAdDetailsRawDataToVehicleHistoryValueObjectMapper = ({config}) =>
    new FromAdDetailsRawDataToVehicleHistoryValueObjectMapper({
      config,
      fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper:
        VehiclesMappersFactory.fromVehicleHistoryRawDataToVehicleHistoryValueObjectMapper({config})
    })

  static fromAdDetailsRawDataToVehicleInfoValueObjectMapper = ({config}) =>
    new FromAdDetailsRawDataToVehicleInfoValueObjectMapper({
      config,
      descriptionItemValueObjectFactory: VehiclesValueObjectsFactory.descriptionItemValueObject,
      fromElectricFeaturesRawDataToElectricFeaturesVOMapper:
        VehiclesMappersFactory.fromElectricFeaturesRawDataToElectricFeaturesVOMapper({config}),
      equipmentSectionValueObjectFactory: VehiclesValueObjectsFactory.equipmentSectionValueObject,
      equipmentValueObjectFactory: VehiclesValueObjectsFactory.equipmentValueObject,
      getUrlService: PageServicesFactory.getUrlService({config}),
      vehicleInfoValueObjectFactory: VehiclesValueObjectsFactory.vehicleInfoValueObject,
      versionSpecificationsValueObjectFactory: VehiclesValueObjectsFactory.versionSpecificationsValueObject
    })

  static httpAdDetailsResponseToAdDetailsAggregateMapper = ({config}) =>
    new HttpAdDetailsResponseToAdDetailsAggregateMapper({
      config,
      adDetailsAggregateFactory: AdsAggregatesFactory.adDetailsAggregate,
      fromAdDetailsRawDataToAdEntityMapper: AdsMappersFactory.fromAdDetailsRawDataToAdEntityMapper({config}),
      fromAdDetailsStatsRawDataToAdStatsValueObjectMapper:
        AdsMappersFactory.fromAdDetailsStatsRawDataToAdStatsValueObjectMapper({
          config
        }),
      fromAdDetailsRawDataToAdTypeValueObjectMapper: AdsMappersFactory.fromAdDetailsRawDataToAdTypeValueObjectMapper({
        config
      }),
      fromAdDetailsRawDataToSellerValueObjectMapper: AdsMappersFactory.fromAdDetailsRawDataToSellerValueObjectMapper({
        config
      }),
      fromAdDetailsRawDataToVehicleCertificationValueObjectMapper:
        AdsMappersFactory.fromAdDetailsRawDataToVehicleCertificationValueObjectMapper({config}),
      fromAdDetailsRawDataToVehicleHistoryValueObjectMapper:
        AdsMappersFactory.fromAdDetailsRawDataToVehicleHistoryValueObjectMapper({config}),
      fromAdDetailsRawDataToVehicleInfoValueObjectMapper:
        AdsMappersFactory.fromAdDetailsRawDataToVehicleInfoValueObjectMapper({
          config
        }),
      financingTermsRawDataToFinancingConditionEntityMapper:
        AdsMappersFactory.financingTermsRawDataToFinancingConditionEntityMapper({config}),
      reservationEntityFactory: AdsEntitiesFactory.reservationEntity
    })

  static adsRawListToAdsListVOMapper = ({config}) =>
    new AdsRawListToAdsListVOMapper({
      config,
      adEntityFactory: AdsEntitiesFactory.adEntity,
      adsListValueObjectFactory: AdsValueObjectsFactory.adsListValueObject
    })

  static lastDetailsViewedDataToLastDetailsViewedListValueObjectMapper = ({config}) =>
    new LastDetailsViewedDataToLastDetailsViewedListValueObjectMapper({
      lastDetailsViewedListValueObjectFactory: AdsValueObjectsFactory.lastDetailsViewedListValueObject,
      lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper:
        AdsMappersFactory.lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper({config})
    })

  static lastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper = ({config}) =>
    new LastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper({
      lastDetailsViewedItemValueObjectFactory: AdsValueObjectsFactory.lastDetailsViewedItemValueObject
    })

  static financingTermsRawDataToFinancingConditionEntityMapper = ({config}) =>
    new FinancingTermsRawDataToFinancingConditionEntityMapper({
      config,
      financingConditionEntityFactory: AdsEntitiesFactory.financingConditionEntity,
      bbvaConditionEntityFactory: AdsEntitiesFactory.bbvaConditionEntity,
      bmwBankConditionEntityFactory: AdsEntitiesFactory.bmwBankConditionEntity,
      cofidisConditionEntityFactory: AdsEntitiesFactory.cofidisConditionEntity,
      caixaConditionEntityFactory: AdsEntitiesFactory.caixaConditionEntity,
      lendrockConditionEntityFactory: AdsEntitiesFactory.lendrockConditionEntity,
      mobilizeConditionEntityFactory: AdsEntitiesFactory.mobilizeConditionEntity,
      stellantisConditionEntityFactory: AdsEntitiesFactory.stellantisConditionEntity,
      santanderConditionEntityFactory: AdsEntitiesFactory.santanderConditionEntity,
      santanderPriConditionEntityFactory: AdsEntitiesFactory.santanderPriConditionEntity,
      vwfsConditionEntityFactory: AdsEntitiesFactory.vwfsConditionEntity,
      confiaConditionEntityFactory: AdsEntitiesFactory.confiaConditionEntity,
      validationError: AdsErrorsFactory.getFinancingDataAdsError
    })

  static fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper = ({config}) =>
    new FromAdAggregationsRawDataToAdAggregationsListValueObjectMapper({
      config,
      adAggregationsValueObjectFactory: AdsValueObjectsFactory.adAggregationsValueObject,
      adAggregationsListValueObjectFactory: AdsValueObjectsFactory.adAggregationsListValueObject,
      fromAdAggregationRawDataToAdAggregationListValueObjectMapper:
        AdsMappersFactory.fromAdAggregationRawDataToAdAggregationListValueObjectMapper({config})
    })

  static fromAdAggregationRawDataToAdAggregationListValueObjectMapper = ({config}) =>
    new FromAdAggregationRawDataToAdAggregationListValueObjectMapper({
      config,
      adAggregationValueObjectFactory: AdsValueObjectsFactory.adAggregationValueObject,
      adAggregationListValueObjectFactory: AdsValueObjectsFactory.adAggregationListValueObject
    })

  static fromSearchParamsToStatsRequestVOMapper = ({config}) =>
    new FromSearchParamsToStatsRequestVOMapper({
      statsRequestVOFactory: AdsValueObjectsFactory.statsRequestValueObject,
      config
    })

  static fromStatsResponseToVOMapper = ({config}) =>
    new FromStatsResponseToVOMapper({
      config,
      statsResponseValueObjectFactory: AdsValueObjectsFactory.statsResponseValueObject
    })

  static fromRecommendedAdsRawDataToRecommendedAdsListVOMapper = ({config}) =>
    new FromRecommendedAdsRawDataToRecommendedAdsListVOMapper({
      // Config
      config,
      // Mappers
      fromAdRawDataToAdEntityMapper: AdsMappersFactory.fromAdRawDataToAdEntityMapper(),
      // Value Objects
      recommendedAdsListValueObjectFactory: AdsValueObjectsFactory.recommendedAdsListValueObjectFactory,
      metadataRecommededAdsValueObject: AdsValueObjectsFactory.metaDataRecommendedAdsValueObject
    })

  static fromAdRawDataToAdEntityMapper = () =>
    new FromAdRawDataToAdEntityMapper({
      adEntityFactory: AdsEntitiesFactory.adEntity,
      packDealerEntity: DealerEntitiesFactory.packEntity
    })

  static fromLoanCalculationsToFinancingDataAggregateMapper = ({config}) =>
    new FromLoanCalculationsToFinancingDataAggregateMapper({
      config,
      financingTermsRawDataToFinancingConditionEntityMapper:
        AdsMappersFactory.financingTermsRawDataToFinancingConditionEntityMapper({config})
    })
}
